import React from 'react';

type Props = {
  content?: string;
  actorName?: string;
  className?: string;
};

export function NotificationBody({ content, actorName, className }: Props) {
  const text = content || '';
  const name = (actorName || '').trim();

  if (name && text.startsWith(name)) {
    return (
      <span className={className}>
        <span className="font-semibold">{name}</span>
        {text.slice(name.length)}
      </span>
    );
  }

  return <span className={className}>{text}</span>;
}

export default NotificationBody;
